import React, { useState } from "react";

import OutlinedInputCustom from "../utility/component/textInput";
import { AccountMasterHelp, DepartmentMasterHelp } from "../help";
import ListDebitNoteHelp from "../help/listDebitHelp";
import { emptyRowDetails } from "./fun";
import uniqueId from "uniqid";
import { useDispatch } from "react-redux";
import { setAlertWithTitle } from "../utility/Redux/modal";
import moment from "moment";
const PartyDetails = ({
  partyDetails,
  setPartyDetails,
  refreshList,
  loadPurchaseBill,
  accountMasterHelpStatus,
  setAccountMasterHelpStatus,
  rows,
  setRows,
  delayedFunction,
  setPurchaseBillNoFocus,
  partyNameRef,
  setPartyMasterCreaterModalStatus,
  issueToRef,
  setIssueToRef,
  issuedByRef,
  setIssuedByRef,
}) => {
  const dispatch = useDispatch();
  const [IssueBillHelpStatus, setIssueBillHelpStatus] = useState(false);
  return (
    <div className="flex h-auto w-auto py-2  ">
      <div
        style={{ border: "1px solid #b5b3b3", borderRadius: "8px" }}
        className="pt-3 px-3 pb-3   bg-[#ffffff]"
      >
        <div className="grid grid-cols-[160px,190px]  d:grid-cols-[200px,150px,180px] gap-3 w-full ">
          <OutlinedInputCustom
            readOnly={true}
            value={partyDetails.DEBIT_NOTE_NO}
            label={"Debit Note No."}
            fontWeight={600}
            search={() => {
              setIssueBillHelpStatus(true);
            }}
          />

          <OutlinedInputCustom
            type={"date"}
            onChange={(e) => {
              const inputValue = e.target.value;
              if (/^\d{4}-\d{2}-\d{2}$/.test(inputValue)) {
                setPartyDetails((prevState) => ({
                  ...prevState,
                  DATE: inputValue,
                }));
              }
            }}
            value={partyDetails.DATE}
            label={"Date"}
          />
        </div>
      </div>

      <div
        style={{ border: "1px solid #b5b3b3", borderRadius: "8px" }}
        className=" bg-white grid grid-cols-[190px,350px] gap-3 p-3 flex-1 ml-3"
      >
        <div className="">
          <OutlinedInputCustom
            search={() => {
              setAccountMasterHelpStatus(true);
            }}
            onChange={() => {
              setAccountMasterHelpStatus(true);
            }}
            width={`calc(100% - 0px)`}
            value={partyDetails.ACCOUNT_NO}
            label={"Acc. Number"}
            autoFocus={true}
            refrance={partyNameRef}
            onKeyDown={(e) => {
              if (e.code === "Enter" || e.code === "NumpadEnter") {
                if (partyDetails.ACCOUNT_NO) {
                  setIssueToRef(true);
                } else {
                  setAccountMasterHelpStatus(true);
                }
              }
            }}
          />
        </div>

        <OutlinedInputCustom
          width={`calc(100% - 0px)`}
          value={partyDetails.NAME}
          label={"Party Name"}
          refrance={issueToRef}
          readOnly={true}
          onKeyDown={(e) => {
            if (e.code === "Enter" || e.code === "NumpadEnter") {
              setIssuedByRef(true);
            }
          }}
        />
      </div>

      <AccountMasterHelp
        onRowClick={(row) => {
          if (!rows.find((r) => r.ITEMNAME)) {
            setAccountMasterHelpStatus(false);
            setRows([
              {
                ...emptyRowDetails,
                id: uniqueId(),
              },
            ]);
            setIssueToRef(true);
            setPartyDetails((old) => {
              return {
                DEBIT_NOTE_NO: "",
                DATE: moment().format("YYYY-MM-DD"),
                ACCOUNT_NO: row.row.ACCOUNT_NO,
                NAME: row.row.NAME,
              };
            });

            setTimeout(() => {
              setIssueToRef(true);
            }, 500);
          } else {
            setAccountMasterHelpStatus(false);
            dispatch(
              setAlertWithTitle({
                title: "Alert",
                msg: "Please clear items before changing account",
              })
            );
          }
        }}
        status={accountMasterHelpStatus}
        onClose={() => {
          setAccountMasterHelpStatus(false);
        }}
      />
      <ListDebitNoteHelp
        onRowClick={(row) => {
          delayedFunction(rows[0].id);
          setIssueBillHelpStatus(false);
          loadPurchaseBill(row.row.DEBIT_NOTE_NO);
        }}
        status={IssueBillHelpStatus}
        onClose={() => {
          setIssueBillHelpStatus(false);
        }}
      />
    </div>
  );
};

export default PartyDetails;
